import { Component, OnInit, ViewChild } from '@angular/core';
import { Router } from '@angular/router';
import { ToastrService } from 'ngx-toastr';
import { DatePipe } from '@angular/common';
import { MatDialog, MatPaginator, MatSort, MatSelect } from '@angular/material';
import { MatTableDataSource } from '@angular/material/table';
import { SelectionModel } from '@angular/cdk/collections';
import { CommonService } from '../../core/service/common-service/common.service';
import { FilterPipePipe } from '../../pipes/filter-pipe.pipe';
import { ListCustData } from './listCustData';
import { openLeadStatusDialog } from 'src/app/modal/lead-status-dialog/lead-status-dialog.component';

@Component({
  selector: 'app-pipeline-management',
  templateUrl: './pipeline-management.component.html',
  styleUrls: ['./pipeline-management.component.scss'],
  providers: [FilterPipePipe]
})
export class PipelineManagementComponent implements OnInit {

  @ViewChild(MatSort, { static: true }) sort: MatSort;
  @ViewChild(MatPaginator, { static: true }) paginator: MatPaginator;

  customerData: any;
  currentDate: string;
  today: Date = new Date();
  spinner: boolean;
  userId: string;
  startDate: Date;
  endDate: Date;
  userRoles: any;
  customerNameValues: string[] = [];
  enquiryIdValues: string[] = [];
  productNAmeValues: string[] = [];
  customerMobileValues: string[] = [];
  callStatusValues: string[] = [];
  chasisNoValues: string[] = [];
  uniqueEnquiryId = new Set<string>();
  uniqueProductName = new Set<string>();
  uniqueChasisNo = new Set<string>();
  uniqueCallStatus = new Set<string>();
  uniqueCustomerMobile = new Set<string>();
  uniqueCustomerName = new Set<string>();
  pageSize: number;
  filterMap = new Map();
  dataSource: any;
  filteredDataSource: any;
  callsToBeMade: number = 0;
  callsMade: number = 0;
  selection: any;
  callFlag: any;
  customersToBeCalled: string;
  callsMade1: string;
  userRoleId: string;
  showpipelinedatareport: boolean = false;
  listFlag: string;
  displayedColumns: string[] = [
    'customerName',
    'enquiryId',
    'productType',
    'vin',
    'custTelNo',
    'leadType',
    'leadStatus',
    'likelyBuyDate',
    'followUp',
  ];
  clickedRow: ListCustData;
  followUpCount: any;

  constructor(private router: Router, private toastr: ToastrService, private commonService: CommonService,
    private datePipe: DatePipe, private filterPipePipe: FilterPipePipe, public dialog: MatDialog) { }

  ngOnInit() {

    if (localStorage.getItem('userId') == null || localStorage.getItem('userId') == undefined) {
      this.router.navigate(['login']);
    }
    this.customerData = JSON.parse(localStorage.getItem('customerData'));
    this.userId = localStorage.getItem('userId');
    this.currentDate = this.datePipe.transform(new Date(), "yyyy-MM-dd");
    this.userRoles = localStorage.getItem('userRoles');

    this.userRoleId = JSON.parse(localStorage.getItem("userInfo"))[0].roleId;
    if (localStorage.getItem('enquiryIdValues') != null || localStorage.getItem('enquiryIdValues') != undefined) {
      let enquiryIdValues = JSON.parse(localStorage.getItem('enquiryIdValues'));
      this.enquiryIdValues = enquiryIdValues;
    }

    if (localStorage.getItem('productNameValues') != null || localStorage.getItem('productNameValues') != undefined) {
      let productNAmeValues = JSON.parse(localStorage.getItem('productNameValues'));
      this.productNAmeValues = productNAmeValues;
    }

    if (localStorage.getItem('chasisNoValues') != null || localStorage.getItem('chasisNoValues') != undefined) {
      let chasisNoValues = JSON.parse(localStorage.getItem('chasisNoValues'));
      this.chasisNoValues = chasisNoValues;
    }

    if (localStorage.getItem('customerMobileValues') != null || localStorage.getItem('customerMobileValues') != undefined) {
      let customerMobileValues = JSON.parse(localStorage.getItem('customerMobileValues'));
      this.customerMobileValues = customerMobileValues;
    }

    if (localStorage.getItem('customerNameValues') != null || localStorage.getItem('customerNameValues') != undefined) {
      let customerNameValues = JSON.parse(localStorage.getItem('customerNameValues'));
      this.customerNameValues = customerNameValues;
    }

    if (localStorage.getItem('callListPageSize') != null || localStorage.getItem('callListPageSize') != undefined) {
      let pagesize = Number(localStorage.getItem('callListPageSize'));
      this.pageSize = (pagesize && !Number.isNaN(pagesize)) ? pagesize : 50;
    } else {
      this.pageSize = 50;
    }

    // if ((localStorage.getItem('workshops') == null || localStorage.getItem('workshops') == undefined) && this.userRoles !='Call Center Agent') {
    //   this.getWorkshopDetails();
    // }
    //this.getCreStats();
    if (this.userRoleId == '1') {
      this.listFlag = 'Z';
      setTimeout(() => this.pipelineCallList(this.userId), 1000);
    } else {
      this.listFlag = 'Y';
      setTimeout(() => this.pipelineCallList(this.userId), 1000);
    }
    //this.clearFilter(false);

    //showpipeline data report
    if(this.userRoleId == "3" || this.userRoleId == "5" || this.userRoleId == "7") {
      this.showpipelinedatareport = true;
    }

  }

  /**
  * Name: setPageData
  * purpose: To set pagesize for table
  */
  setPageData(event) {
    let size = event.pageSize.toString();
    localStorage.setItem('callListPageSize', size);
  }

  showLeadStatusDialog() {
    openLeadStatusDialog(this.dialog, this.clickedRow).subscribe(val => {
      if (val == -1) {
        this.ngOnInit();
      }
    });

  }

  showPipelineSearch() {
    this.router.navigate(['pipeline-search']);
  }

  /**
    * Name: getWorkshopDetails
    * purpose: To get CRE assigned workshop details
    */
  getWorkshopDetails() {
    this.spinner = true;
    this.commonService.getWorkshopDetails(this.userId)
      .subscribe(res => {
        if (res['responseCode'] == 0) {
          this.spinner = false;
          localStorage.setItem('workshops', JSON.stringify(res['responseData']));
        } else {
          this.spinner = false;
          this.toastr.error(res['message'], "Error");
        }
      }, err => {
        this.spinner = false;
        this.toastr.error("Something went wrong, Please try again.", "Error");
      });
  }

  /**
   * Name: activeButton
   * purpose: To activat apply button
   */
  activeButton(): boolean {
    let flag = false;
    if (this.enquiryIdValues != null && this.enquiryIdValues.length != 0) {
      flag = true;
    } else if (this.productNAmeValues != null && this.productNAmeValues.length != 0) {
      flag = true;
    } else if (this.chasisNoValues != null && this.chasisNoValues.length != 0) {
      flag = true;
    } else if (this.callStatusValues != null && this.callStatusValues.length != 0) {
      flag = true;
    } else if (this.customerMobileValues != null && this.customerMobileValues.length != 0) {
      flag = true;
    } else if (this.customerNameValues != null && this.customerNameValues.length != 0) {
      flag = true;
    }
    return flag;
  }

  downloadPipelineReport(): void {
    let fdate = this.datePipe.transform(this.startDate, "yyyy-MM-dd");
    let tdate = this.datePipe.transform(this.endDate, "yyyy-MM-dd");
    let fileName = "Pipeline_Data Status Report_From_" + fdate + "_To_" + tdate;

    this.commonService.getPipelineDataReport(fdate, tdate, this.userId)
      .subscribe(fileData => {
        if (fileData) {
          const blob: any = new Blob([fileData], { type: 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet' });
          let link = document.createElement("a");
          if (link.download !== undefined) {
            let url = URL.createObjectURL(blob);
            link.setAttribute("href", url);
            link.setAttribute("download", fileName);
            document.body.appendChild(link);
            link.click();
            document.body.removeChild(link);
            this.spinner = false;
          }
        } else {
          this.spinner = false;
        }
      }, err => {
        this.spinner = false;
      });
  }

  getPipelineRegionWiseDataReport(): void{
    let fdate = this.datePipe.transform(this.startDate, "yyyy-MM-dd");
    let tdate = this.datePipe.transform(this.endDate, "yyyy-MM-dd");
    let fileName = "PipelineRegionWise_Data Status Report_From_" + fdate + "_To_" + tdate;

    this.commonService. getPipelineRegionWiseDataReport(fdate, tdate, this.userId, this.userRoleId)
      .subscribe(fileData => {
        if (fileData) {
          const blob: any = new Blob([fileData], { type: 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet' });
          let link = document.createElement("a");
          if (link.download !== undefined) {
            let url = URL.createObjectURL(blob);
            link.setAttribute("href", url);
            link.setAttribute("download", fileName);
            document.body.appendChild(link);
            link.click();
            document.body.removeChild(link);
            this.spinner = false;
          }
        } else {
          this.spinner = false;
        }
      }, err => {
        this.spinner = false;
      });

  }

  /**
   * Name: applyfilter
   * purpose: To apply filter on call list data
   */
  applyfilter(): void {
    let key = '';
    this.filterMap = new Map();
    this.filteredDataSource = this.dataSource;

    if (this.customerNameValues != null && this.customerNameValues.length != 0) {
      key = "customerName";
      this.filterMap.set(key, this.customerNameValues);
      this.filteredDataSource = new MatTableDataSource<ListCustData>(this.filterPipePipe.transform(this.filteredDataSource.filteredData, this.filterMap));
    }

    if (this.enquiryIdValues != null && this.enquiryIdValues.length != 0) {
      key = "enquiryId";
      this.filterMap.set(key, this.enquiryIdValues);
      this.filteredDataSource = new MatTableDataSource<ListCustData>(this.filterPipePipe.transform(this.filteredDataSource.filteredData, this.filterMap));
    }

    if (this.productNAmeValues != null && this.productNAmeValues.length != 0) {
      key = "productType";
      this.filterMap.set(key, this.productNAmeValues);
      this.filteredDataSource = new MatTableDataSource<ListCustData>(this.filterPipePipe.transform(this.filteredDataSource.filteredData, this.filterMap));
    }

    if (this.chasisNoValues != null && this.chasisNoValues.length != 0) {
      key = "vin";
      this.filterMap.set(key, this.chasisNoValues);
      this.filteredDataSource = new MatTableDataSource<ListCustData>(this.filterPipePipe.transform(this.filteredDataSource.filteredData, this.filterMap));
    }

    if (this.callStatusValues != null && this.callStatusValues.length != 0) {
      key = "leadStatus";
      this.filterMap.set(key, this.callStatusValues);
      this.filteredDataSource = new MatTableDataSource<ListCustData>(this.filterPipePipe.transform(this.filteredDataSource.filteredData, this.filterMap));
    }

    if (this.customerMobileValues != null && this.customerMobileValues.length != 0) {
      key = "custTelNo";
      this.filterMap.set(key, this.customerMobileValues);
      this.filteredDataSource = new MatTableDataSource<ListCustData>(this.filterPipePipe.transform(this.filteredDataSource.filteredData, this.filterMap));
    }

    //this.filterMap.set(this.selectedCol, this.selectedColValues);
    //this.filteredDataSource = new MatTableDataSource<ListCustData>(this.filterPipePipe.transform(this.dataSource.filteredData, this.filterMap));
    this.callsToBeMade = this.filteredDataSource.filteredData.length;
    this.sort.direction = '';
    this.filteredDataSource.sort = this.sort;
    this.filteredDataSource.sortingDataAccessor = (data, header) => data[header];
    this.filteredDataSource.paginator = this.paginator;
    localStorage.setItem('enquiryIdValues', JSON.stringify(this.enquiryIdValues));
    localStorage.setItem('productNameValues', JSON.stringify(this.productNAmeValues));
    localStorage.setItem('chasisNoValues', JSON.stringify(this.chasisNoValues));
    localStorage.setItem('callStatusValues', JSON.stringify(this.callStatusValues));
    localStorage.setItem('customerMobileValues', JSON.stringify(this.customerMobileValues));
    localStorage.setItem('customerNameValues', JSON.stringify(this.customerNameValues));
    //localStorage.setItem('selectedCol', this.selectedCol);
    //localStorage.setItem('selectedColValues', JSON.stringify(this.selectedColValues));
  }

  /**
   * Name: searchfilter
   * purpose: To apply filter on call list data
   */
  searchfilter(filterValue: string): void {
    filterValue = filterValue.trim(); // Remove whitespace
    filterValue = filterValue.toLowerCase(); // Datasource defaults to lowercase matches
    this.filteredDataSource.filter = filterValue;
  }

  /**
    * Name: amcpairCallList
    * purpose: To get calllist details
    * @param {string} flag - type of call
    * @param {string} creId - User Id
    */
  pipelineCallList(creId: string): void {
    this.spinner = true;
    this.selection = new SelectionModel<ListCustData>(true, []);

    this.commonService.pipelineCustomerCallList(creId)
      .subscribe(res => {
        if (res['responseCode'] == 0 && res['responseData'] != undefined) {
          this.callsToBeMade = res['responseData'].length;
          //init data table and shorting
          this.dataSource = new MatTableDataSource<ListCustData>(res['responseData']);
          //this.sort.direction = '';
          this.followUpCount = res['responseData'][0].followUpCount;
          this.dataSource.sort = this.sort;
          this.dataSource.sortingDataAccessor = (data, header) => data[header];
          this.dataSource.paginator = this.paginator;
          this.filterData();
          if ((!this.enquiryIdValues || this.enquiryIdValues.length == 0)
            && (!this.productNAmeValues || this.productNAmeValues.length == 0)
            && (!this.chasisNoValues || this.chasisNoValues.length == 0)
            && (!this.callStatusValues || this.callStatusValues.length == 0)
            && (!this.customerMobileValues || this.customerMobileValues.length == 0)
            && (!this.customerNameValues || this.customerNameValues.length == 0)
          ) {
            //init filtered table and shorting
            this.filteredDataSource = new MatTableDataSource<ListCustData>(res['responseData']);
            //this.sort.direction = '';
            this.filteredDataSource.sort = this.sort;
            this.filteredDataSource.sortingDataAccessor = (data, header) => data[header];
            this.filteredDataSource.paginator = this.paginator;
          }
          this.spinner = false;
        } else {
          this.spinner = false;
          this.toastr.error(res['message'], "Error");
        }
      }, err => {
        this.spinner = false;
        this.toastr.error("Something went wrong, Please try again.", "Error");
      });
  }

  /**
    * Name: selectCustomer
    * purpose: To select customer for details
    * @param {Object} row - selected customer details
    */
  selectCustomer(row: ListCustData): void {
    this.clickedRow = row;
    localStorage.setItem('customerId', row.enquiryId);
    localStorage.setItem("pipelinecustomerData", JSON.stringify(row));
    if (this.clickedRow.leadStatus == "Deal Closed") {
      this.toastr.error("Lead Closed.");
    }else if(this.clickedRow.leadStatus == "Lost"){
      this.toastr.error("Lost Lead.");
    }
     else {
      this.showLeadStatusDialog();
    }

  }

  /**
  * Name: filterData
  * purpose: To filter call list data
  */
  filterData(): void {
    this.dataSource.filteredData.forEach(element => {
      this.uniqueEnquiryId.add(element.enquiryId);
      this.uniqueProductName.add(element.productType);
      this.uniqueChasisNo.add(element.vin);
      this.uniqueCallStatus.add(element.leadStatus);
      this.uniqueCustomerMobile.add(element.custTelNo);
      this.uniqueCustomerName.add(element.customerName);
    });

    if ((this.enquiryIdValues != null && this.enquiryIdValues.length != 0)
      || (this.productNAmeValues != null && this.productNAmeValues.length != 0)
      || (this.chasisNoValues != null && this.chasisNoValues.length != 0)
      || (this.callStatusValues != null && this.callStatusValues.length != 0)
      || (this.customerMobileValues != null && this.customerMobileValues.length != 0)
      || (this.customerNameValues != null && this.customerNameValues.length != 0)
    ) {
      //this.filterTriggered(null);
      this.applyfilter();
    }
  }

  /**
  * Name: clearFilter
  * purpose: To clear filter
  */
  clearFilter(listChange: boolean): void {
    if (listChange) {
      this.dataSource = [];
      this.filteredDataSource = [];
      this.pipelineCallList(this.userId);
    } else {
      this.filterMap.clear();
      this.enquiryIdValues = null;
      this.productNAmeValues = null;
      this.chasisNoValues = null;
      this.callStatusValues = null;
      this.customerMobileValues = null;
      this.customerNameValues = null;
      this.startDate = null;
      this.endDate = null;
      this.filteredDataSource = new MatTableDataSource<ListCustData>(this.filterPipePipe.transform(this.dataSource.filteredData, this.filterMap));
      this.callsToBeMade = this.filteredDataSource.filteredData.length;
      this.sort.direction = '';
      this.filteredDataSource.sort = this.sort;
      this.filteredDataSource.sortingDataAccessor = (data, header) => data[header];
      this.filteredDataSource.paginator = this.paginator;
      localStorage.removeItem('enquiryIdValues');
      localStorage.removeItem('productNAmeValues');
      localStorage.removeItem('chasisNoValues');
      localStorage.removeItem('callStatusValues');
      localStorage.removeItem('customerMobileValues');
      localStorage.removeItem('customerNameValues');

    }
  }

  /**
   * Name: changeColor
   * purpose: To change followup time color
   */
  changeColor(followUpDate: any): String {
    let currentTime = this.datePipe.transform(new Date(), "yyyy-MM-dd HH:mm:ss ");

    if (followUpDate != null && followUpDate != undefined && followUpDate != "") {
      let followUpDateTime = this.datePipe.transform(followUpDate, "yyyy-MM-dd HH:mm:ss");
      if ((new Date(currentTime)).getTime() > (new Date(followUpDateTime).getTime())) {
        return "red";
      }
    }
  }
}

